import { generateUUID, MD5 } from "@/utils/crypto";
// 灵犀请求头
export function getLingXiManagerHeaders() {
    /* let deviceInfo: any = {}
    const deviceInfoData = sessionStorage.getItem('deviceInfo');
    if (deviceInfoData) {
      deviceInfo = JSON.parse(window.atob(deviceInfoData));
    } */
    const deviceInfo = {
        deviceId: "1899013964170694658",
        productId: "1899007766144614401",
        productKey: "GxoUFLbDhbOqnqab",
        deviceNo: "869700070000570",
        deviceSecret: "oimAfaiQHiagMwEe",
    };
    const { productId, deviceId, productKey, deviceNo, deviceSecret } = deviceInfo;
    const timestamp = String(Math.floor(Date.now()));
    const token = window.localStorage.getItem("token");
    const uuid = generateUUID();
    const headers = {
        Authorization: token ? "Bearer " + token : undefined,
        "client-id": localStorage.getItem('clientId') || "lingxi_h5",
        "project-code": "lingxi",
        version: "3",
        ts: timestamp,
        productId,
        productKey,
        deviceId,
        deviceNo,
        sign: MD5(deviceSecret + timestamp),
        appSource: "private",
        "X-Request-Id": uuid,
        modelName: "M520 Pro",
        packageName: "com.xunfei.mouse",
    };
    return headers;
}
